export function getPrivateDashboardDeploymentsTooltip(deployments: string[]) {
	return deployments.length > 0 ? deployments.join(', ') : 'None specified';
}
